module.exports = __webpack_public_path__ + "img/4.fd5c9287.png";